import { Contact, RequestStatus, User } from "../interfaces";

export class RequestConnection{
    content?:string;
    from? :string;
    organization_name? :string;
    request_type? :string;
    to? :Contact
    id? : string
    actor_type? : any
    status? : RequestStatus
    city? : string
    cityRaw? : string

    constructor(id:string, content:string, from : User, to:Contact, status: RequestStatus, request_type:string, actor?:any){
        this.id = id;
        this.from = `${from.first_name} ${from.last_name}` 
        this.content = content;
        this.to = to;
        this.status = status;
        this.organization_name = to.organization_name;
        this.request_type = request_type;
        this.actor_type = actor;
        this.city = to.city;
        this.cityRaw = to.cityRaw;
    }
}